var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5 1L8.5 8L1.5 15","stroke":"#242424","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
